import React, { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  ToggleButton,
  ToggleButtonGroup,
  Box,
  CardMedia,
} from '@mui/material'
import ApiEndPoints from './common/ApiEndpoints'
import useNotification from './common/Notification'
import bjpImage from '../bjp-image.webp' // Adjust path as needed

const TemplatesType1 = () => {
  const showNotification = useNotification()
  const [template, setTemplate] = useState('grid')
  const [dataTemplate, setDataTemplate] = useState([])

  useEffect(() => {
    const fetchTemplatesData = async () => {
      try {
        const response = await ApiEndPoints.templatesType1()
        console.log('Templates Responses: ', response)
        setDataTemplate(response.data.data)
      } catch (error) {
        showNotification(error.response?.data?.message, 'error')
      }
    }
    fetchTemplatesData()
  }, [])

  const handleTemplateChange = (event, newTemplate) => {
    if (newTemplate) setTemplate(newTemplate)
  }

  const selectedStyles = {
    '&.Mui-selected': {
      backgroundColor: 'primary.main',
      color: 'white',
      '&:hover': {
        backgroundColor: 'primary.dark',
      },
    },
  }
  return (
    <Box
      sx={{
        marginTop: '1rem',
        '@media(max-width:768px)': {
          marginTop: '3rem',
          marginLeft: -10,
          marginRight: -2,
          // minWidth: '350px',
        },
      }}
    >
      <div style={{ padding: 20 }}>
        <Typography
          fontWeight="bold"
          variant="h4"
          gutterBottom
          sx={{ color: 'primary.main' }}
        >
          Watermark Templates View
        </Typography>

        <ToggleButtonGroup
          value={template}
          exclusive
          onChange={handleTemplateChange}
          aria-label="template selection"
          sx={{ marginBottom: 6 }}
        >
          <ToggleButton value="grid" sx={selectedStyles}>
            Grid View
          </ToggleButton>
          <ToggleButton value="card" sx={selectedStyles}>
            Card View
          </ToggleButton>
          <ToggleButton value="list" sx={selectedStyles}>
            List View
          </ToggleButton>
        </ToggleButtonGroup>

        {template === 'card' && dataTemplate.length > 0 && (
          <Card
            sx={{
              maxWidth: 400,
              margin: 'auto',
              padding: 2,
              borderRadius: 3,
              boxShadow: 3,
              textAlign: 'center',
              backgroundColor: '#f5f5f5',
              mb: 2,
            }}
          >
            {/* Card Image */}
            <CardMedia
              component="img"
              height="200"
              image={bjpImage} // Use the imported variable
              alt="Template Image"
              sx={{
                borderRadius: '10px',
                objectFit: 'cover',
              }}
            />

            {/* Card Content */}
            <CardContent sx={{ textAlign: 'left' }}>
              <Typography sx={{ color: '#333', fontSize: 16 }}>
                {dataTemplate[0].type} :{' '}
                <Typography
                  component="span"
                  sx={{
                    color: 'primary.main',
                    fontWeight: 'bold',
                    fontSize: 16,
                  }}
                >
                  {dataTemplate[0].sub_type}
                </Typography>
              </Typography>

              <Typography sx={{ mt: 1, fontSize: 16 }}>
                TEMPLATE STATUS :{' '}
                <Typography
                  component="span"
                  sx={{ color: 'green', fontWeight: 'bold' }}
                >
                  {dataTemplate[0].template_status}
                </Typography>
              </Typography>

              <Typography sx={{ mt: 1, fontSize: 16 }}>
                VALID DATE :{' '}
                <Typography
                  component="span"
                  sx={{ color: 'error.main', fontWeight: 'bold' }}
                >
                  {dataTemplate[0].valid_date}
                </Typography>
              </Typography>
            </CardContent>
          </Card>
        )}

        {template === 'list' && dataTemplate.length > 0 && (
          <List container justifyContent="space-between">
            {dataTemplate.map((item, index) => (
              <Card
                sx={{
                  maxWidth: 400,
                  margin: 'auto',
                  padding: 2,
                  borderRadius: 3,
                  boxShadow: 3,
                  textAlign: 'center',
                  backgroundColor: '#f5f5f5',
                  mb: 2,
                }}
              >
                {/* Card Image */}
                <CardMedia
                  component="img"
                  height="200"
                  image={bjpImage} // Use the imported variable
                  alt="Template Image"
                  sx={{
                    borderRadius: '10px',
                    objectFit: 'cover',
                  }}
                />

                {/* Card Content */}
                <CardContent sx={{ textAlign: 'left' }}>
                  <Typography sx={{ color: '#333', fontSize: 16 }}>
                    {dataTemplate[0].type} :{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: 'primary.main',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                    >
                      {dataTemplate[0].sub_type}
                    </Typography>
                  </Typography>

                  <Typography sx={{ mt: 1, fontSize: 16 }}>
                    TEMPLATE STATUS :{' '}
                    <Typography
                      component="span"
                      sx={{ color: 'green', fontWeight: 'bold' }}
                    >
                      {dataTemplate[0].template_status}
                    </Typography>
                  </Typography>

                  <Typography sx={{ mt: 1, fontSize: 16 }}>
                    VALID DATE :{' '}
                    <Typography
                      component="span"
                      sx={{ color: 'error.main', fontWeight: 'bold' }}
                    >
                      {dataTemplate[0].valid_date}
                    </Typography>
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </List>
        )}

        {template === 'grid' && dataTemplate.length > 0 && (
          <Grid container justifyContent="space-between">
            {dataTemplate.map((item, index) => (
              <Card
                sx={{
                  maxWidth: 400,
                  margin: 'auto',
                  padding: 2,
                  borderRadius: 3,
                  boxShadow: 3,
                  textAlign: 'center',
                  backgroundColor: '#f5f5f5',
                  mb: 2,
                }}
              >
                {/* Card Image */}
                <CardMedia
                  component="img"
                  height="200"
                  image={bjpImage} // Use the imported variable
                  alt="Template Image"
                  sx={{
                    borderRadius: '10px',
                    objectFit: 'cover',
                  }}
                />

                {/* Card Content */}
                <CardContent sx={{ textAlign: 'left' }}>
                  <Typography sx={{ color: '#333', fontSize: 16 }}>
                    {dataTemplate[0].type} :{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: 'primary.main',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                    >
                      {dataTemplate[0].sub_type}
                    </Typography>
                  </Typography>

                  <Typography sx={{ mt: 1, fontSize: 16 }}>
                    TEMPLATE STATUS :{' '}
                    <Typography
                      component="span"
                      sx={{ color: 'green', fontWeight: 'bold' }}
                    >
                      {dataTemplate[0].template_status}
                    </Typography>
                  </Typography>

                  <Typography sx={{ mt: 1, fontSize: 16 }}>
                    VALID DATE :{' '}
                    <Typography
                      component="span"
                      sx={{ color: 'error.main', fontWeight: 'bold' }}
                    >
                      {dataTemplate[0].valid_date}
                    </Typography>
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Grid>
        )}
      </div>
    </Box>
  )
}

export default TemplatesType1
